const brandAttrsToSelector = attrs => Object.entries(attrs)
  .map(([key, value]) => `[${key}="${value}"]`)
  .join('');

export const styleBrandAttrs = (brandName = '') => ({'data-id': `widget-${brandName}-style`});

export const styleBrandSelector = (brandName = '') => (`style${brandAttrsToSelector(styleBrandAttrs(brandName))}`);
